/**
 * @file src/config/routes.js
 * @description Centralised route path constants.
 * Rules:
 *  - No functions, no React, no logic — pure strings only
 *  - Every route path in Routes.jsx and every navigate() call
 *    in the codebase must reference these constants instead of
 *    hardcoded strings
 *  - Grouping mirrors the sidebar / app structure
 */

// ---------------------------------------------------------------------------
// Public routes (no auth required)
// ---------------------------------------------------------------------------

export const ROUTES = {
  // ── Public ───────────────────────────────────────────────────────────────
  LANDING: "/",
  LOGIN: "/login",
  OAUTH_CALLBACK: "/oauth-callback",
  ACCEPT_INVITE: "/accept-invite",

  // ── Onboarding (auth required, no company required) ──────────────────────
  COMPANY_ONBOARDING: "/company-onboarding-wizard",
  COMPANY_SUCCESS: "/company-setup-success",
  COMPANY_SELECT: "/select-company",

  // ── Core app (auth + company required) ───────────────────────────────────
  DASHBOARD: "/dashboard",
  ACCOUNTING: "/accounting",

  // ── Invoices ─────────────────────────────────────────────────────────────
  INVOICE_HUB: "/invoice-management-hub",
  INVOICE_CREATE: "/invoice-creation-wizard",
  INVOICE_QUEUE: "/invoice-processing-queue",
  INVOICE_UPLOAD: "/upload-invoice",
  INVOICE_COMPLETION: "/processing-completion-summary",
  INVOICE_CORRECTION: "/invoice-error-correction",

  // ── Clients & Vendors ────────────────────────────────────────────────────
  CLIENT_MANAGEMENT: "/client-management",
  VENDOR_MANAGEMENT: "/vendor-management",

  // ── Products & Payments ──────────────────────────────────────────────────
  PRODUCT_MANAGEMENT: "/product-management",
  PAYMENT_MANAGEMENT: "/payment-management",

  // ── Refunds ──────────────────────────────────────────────────────────────
  REFUNDS: "/refunds",

  // ── Purchases ────────────────────────────────────────────────────────────
  PURCHASES_DASHBOARD: "/purchases/dashboard",
  PURCHASES_EXPENSES: "/expenses",
  PURCHASES_OPERATING: "/purchases/expenses/operating",
  PURCHASES_BILL: "/purchases/expenses/bill",
  PURCHASES_EQUIPMENT: "/purchases/expenses/equipment",
  PURCHASES_PAYMENTS: "/purchases/payments",
  PURCHASES_REFUNDS: "/purchases/refunds",
  PURCHASES_REFUND_NEW: "/purchases/refunds/new",
  PURCHASES_CN_NEW: "/purchases/credit-notes/new",

  // ── Purchase Orders ───────────────────────────────────────────────────────
  PURCHASE_ORDERS: "/purchase-orders",
  PURCHASE_ORDER_NEW: "/purchase-order-wizard",

  // ── Settings & Admin ─────────────────────────────────────────────────────
  COMPANY_SETTINGS: "/company-settings",
  USER_MANAGEMENT: "/user-management",
  DEVICE_SETTINGS: "/device-settings",
  AUDIT_LOGS: "/audit-logs",

  BRANCH_MANAGEMENT: "/branches",

  // ── Fallback ──────────────────────────────────────────────────────────────
  NOT_FOUND: "*",
};
